import MainTable from '../index'

const HomeTable = ({ products, setClickedId, setClickedEdit, handleTransform }) => {
  const isFound = () => {
    return false
  }

  return (
    <MainTable
      products={products}
      isFound={isFound}
      isHomePage={'home'}
      setClickedId={setClickedId}
      setClickedEdit={setClickedEdit}
      handleTransform={handleTransform}
    />
  )
}
export default HomeTable
